import axios from "./axios/request";

export const getList = params => axios({
  url: '/index/getArticle',
  //形参
  params
})


export const getDetail = params => axios({
  url: '/index/getNewsDetail',
  //形参
  params
})